import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { CompanyDTO, CompanyOptimizedDTO } from '../types';

interface CompaniesStore {
    companies: CompanyOptimizedDTO[];
    isLoading: boolean;
    error: string | null;
    setCompanies: (data: CompanyOptimizedDTO[]) => void;
    setLoading: (isLoading: boolean) => void;
    setError: (error: null | string) => void;
    getCompaniesByIds: (ids: string[]) => CompanyOptimizedDTO[] | undefined;
};

export const useCompaniesStore = create<CompaniesStore>()(
    devtools((set, get) => ({
        companies: [],
        isLoading: true,
        error: null,
        setCompanies: (data) => set({ companies: data }),
        getCompaniesByIds: (ids) => {
            return get().companies.filter(comp => {
                return ids.some(id => id === comp.id);
            });
        },
        setLoading: (isLoading: boolean) => set({ isLoading }),
        setError: (error: string | null) => set({ error }),
    }))
);